/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'account-lock': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M22 17v-.5a2.5 2.5 0 00-5 0v.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1m-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.5M8 8c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4m6 12H4v-2c0-2.21 3.58-4 8-4 1.27 0 2.46.15 3.53.41-.21.41-.38.84-.46 1.3-.65.55-1.07 1.37-1.07 2.29v2z"/>'
  }
})
